import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  FETCH_PROVIDERS,
  FETCH_PROVIDERS_SUCCESS,
  FETCH_PROVIDERS_FAILURE,
  FETCH_PERMISSIONS,
  FETCH_PERMISSIONS_SUCCESS,
  FETCH_PERMISSIONS_FAILURE,
  FETCH_FACILITIES_SUCCESS,
  FETCH_FACILITIES_FAILURE
} from "./actionTypes";

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}

export const fetchProviders = () => {
  return {
    type: FETCH_PROVIDERS,
  };
};

export const fetchProvidersSuccess = (providers) => {
  return {
    type: FETCH_PROVIDERS_SUCCESS,
    payload: providers,
  };
};

export const fetchProvidersFailure = (error) => {
  return {
    type: FETCH_PROVIDERS_FAILURE,
    payload: error,
  };
};

export const fetchPermissions = () => ({
  type: FETCH_PERMISSIONS,
});

export const fetchPermissionsSuccess = (permissions) => ({
  type: FETCH_PERMISSIONS_SUCCESS,
  payload: permissions,
});

export const fetchPermissionsFailure = (error) => ({
  type: FETCH_PERMISSIONS_FAILURE,
  payload: error,
});

export const fetchFacilitiesSuccess = (facilities) => ({
  type: FETCH_FACILITIES_SUCCESS,
  payload: facilities,
});

export const fetchFacilitiesFailure = (error) => ({
  type: FETCH_FACILITIES_FAILURE,
  payload: error,
});